import { BaseRouteService } from "./BaseRouteService";
/**
 * The mapservice makes the playersession accesible.
 */
export class MapService extends BaseRouteService {
    public async travelRoom(roomAlias: string): Promise<string> {
        return this.postJsonApi("game/rooms", { alias: roomAlias });
    }
}
